<div #tabVisibility [hidden]="!viewCondition">
    <mat-tab-group (selectedTabChange)="onTabChanged($event)" [(selectedIndex)]="selectedIndex" [dynamicHeight]="true">
        <ng-container *ngFor="let child of children; index as i">
            <mat-tab
                [label]="(tabItems?.length ?? 0) > 0 ? (tabItems[i]?.label ?? '') : (label[i] ?? '')"
                [disabled]="(tabItems?.length ?? 0) > 0 && tabItems[i]?.isDeactivated == true">
                <div class="tabcontent">
                    <ng-template #children></ng-template>
                </div>
            </mat-tab>
        </ng-container>
    </mat-tab-group>
</div>